import styles from "./FAQ.module.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import RightArrow from "../../../../modules/pages/home/collaborators/components/RightArrow";
import LeftArrow from "../../../../modules/pages/home/collaborators/components/LeftArrow";
import Title from "../Title/Title";
import FAQCard from "./FAQCard";

export default function FAQ({ title, faq }) {
  const responsive = {
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 768, min: 576 },
      items: 2,
    },
    miniDesktop: {
      breakpoint: { max: 1200, min: 768 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 1700, min: 1200 },
      items: 4,
    },
    extraDesktop: {
      breakpoint: { max: 4000, min: 1700 },
      items: 5,
    },
  };

  return (
    <section className={`${styles.faq}`}>
      <Title titleText={title} />

      <Carousel
        responsive={responsive}
        customRightArrow={<RightArrow />}
        customLeftArrow={<LeftArrow />}
        renderArrowsWhenDisabled={true}
        autoPlay={true}
        autoPlaySpeed={4000}
        infinite={true}
        className={styles.list}
      >
        {faq.map(item => (
          <FAQCard key={`faq-${item.id}`} {...item} />
        ))}
      </Carousel>
    </section>
  );
}
